import NewOrganization from './NewOrganization';

export default NewOrganization



// WEBPACK FOOTER //
// ./src/components/forms/NewOrganizationForm/index.jsx